module.exports = __webpack_public_path__ + "img/Egesio-G.f048b4b9.png";